/**
 * 前端静态菜单配置（不从数据库读取）
 * 结构参考 CRMEB Admin：一级菜单 + 二级子菜单
 */
export const sideMenus = [
  {
    key: 'dashboard',
    title: '工作台',
    icon: 'DesktopOutlined',
    path: '/',
  },
  {
    key: 'site_application',
    title: '应用',
    icon: 'CloudServerOutlined',
    children: [
      { key: '/siteApplication', title: '应用管理', path: '/siteApplication' },
      { key: '/pageSeo', title: '页面SEO', path: '/pageSeo' },
    ],
  },
    {
        key: 'ai',
        title: 'AI',
        icon: 'RobotOutlined',
        children: [
            { key: '/aiAgent/new', title: '新建对话', path: '/aiAgent/new' },
            { key: '/aiSkill', title: 'Skill管理', path: '/aiSkill' },
            { key: '/aiAgent/history', title: '会话记录', path: '/aiAgent/history' },
            { key: '/aiAgentTask', title: '自动化任务', path: '/aiAgentTask' },
        ],
    },
  {
    key: 'content',
    title: '内容',
    icon: 'FileTextOutlined',
    children: [
      {
        key: 'article',
        title: '文章',
        children: [
          { key: '/articleCategory', title: '文章分类', path: '/articleCategory' },
          { key: '/article', title: '文章列表', path: '/article' },
        ],
      },
    ],
  },
  {
    key: 'product',
    title: '产品',
    icon: 'AppstoreOutlined',
    children: [
      { key: '/productCategory', title: '产品分类', path: '/productCategory' },
      { key: '/product', title: '产品列表', path: '/product' },
    ],
  },
  {
    key: 'ad',
    title: '广告',
    icon: 'PictureOutlined',
    children: [
      { key: '/adCategory', title: '广告分类', path: '/adCategory' },
      { key: '/ad', title: '广告列表', path: '/ad' },
    ],
  },
  {
    key: 'tag',
    title: '标签',
    icon: 'TagsOutlined',
    children: [
      { key: '/tagCategory', title: '标签分类', path: '/tagCategory' },
      { key: '/tag', title: '标签管理', path: '/tag' },
    ],
  },
  {
    key: 'file',
    title: '文件',
    icon: 'FolderOpenOutlined',
    children: [
      { key: '/file', title: '文件列表', path: '/file' },
      { key: '/fileCategory', title: '文件分类', path: '/fileCategory' },
    ],
  },
  {
    key: 'nav',
    title: '导航',
    icon: 'MenuOutlined',
    children: [
      { key: '/nav', title: '导航菜单', path: '/nav' },
    ],
  },
  {
    key: 'user',
    title: '用户',
    icon: 'TeamOutlined',
    children: [
      { key: '/user', title: '用户列表', path: '/user' },
    ],
  },
  {
    key: 'system',
    title: '系统',
    icon: 'SettingOutlined',
    children: [
      { key: '/site', title: '系统管理', path: '/site' },
      { key: '/admin', title: '管理员', path: '/admin' },
      { key: '/aiModel', title: 'AI模型', path: '/aiModel' },
      { key: '/system', title: '系统设置', path: '/system' },
      { key: '/personal', title: '个人资料', path: '/personal' },
    ],
  },
]

/** 根据当前 path 反查所属一级菜单 */
function findChildByPath(children, path) {
  for (const child of children || []) {
    if (child.path === path) return child
    const nested = findChildByPath(child.children, path)
    if (nested) return nested
  }
  return null
}

export function findMenuByPath(path) {
  for (const item of sideMenus) {
    if (item.path === path) {
      return { parent: item, child: null }
    }
    const child = findChildByPath(item.children, path)
    if (child) {
      return { parent: item, child }
    }
  }
  return { parent: sideMenus[0], child: null }
}
